<template>
      <div class="showGroups" v-if="view === 'schedule'">
        <div class="cursor-pointer byTime" :class="{'active':showGroupMode === 'byTime'}" v-on:click="changeShowGroupMode('byTime')">
          BY TIME
          </div>
          <div class="cursor-pointer byPlace" :class="{'active':showGroupMode === 'byPlace'}" v-on:click="changeShowGroupMode('byPlace')">
          BY PLACE
          </div>
      </div>
</template>
<script>
export default {
  name: 'app',
  props: {
    showGroupMode: String,
    view: String
  },
  components: {},
  methods: {
    changeShowGroupMode: function (newVal) {
      this.$emit('showGroupModeSelected', newVal)
    }
  }
}

</script>
